import { Component, Input } from '@angular/core';
import { Organization, OrganizationDefaultValues } from '../org';
import { OrganizationService } from 'src/app/services/organization.service';
import { ProvinceService } from 'src/app/services/province.service';

@Component({
    selector: 'app-org-form',
    templateUrl: './org-form.component.html',
    styleUrls: ['./org-form.component.scss'],
    standalone: false
})
export class OrgFormComponent {
  @Input() org:Organization=OrganizationDefaultValues();
  @Input() isSubmitted:boolean=false;
  province:any[]=[];

  constructor(private _orgservice:OrganizationService,private provinceservice:ProvinceService) { }

  ngOnInit()
  {
      this.provinceservice.getProvinces().subscribe({
        next:(data)=>
        {
          this.province=data;
        }
      })
  }
}
